import { render } from "./SimulationInputs.vue?vue&type=template&id=56c3ec36"
import script from "./SimulationInputs.vue?vue&type=script&lang=js"
export * from "./SimulationInputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__